export const environment = {
  production: false,
  ktRootUri: "https://dev.kingtrivia.com",
  domainAppend: "dev",
  hostUri: "https://devhost.kingtrivia.com"
};
